export default {
  'Boston Celtics': {
    displayName: 'BOS Celtics',
    logoUrl: 'nba/boston_celtics.webp',
  },
  'Brooklyn Nets': {
    displayName: 'BKN Nets',
    logoUrl: 'nba/brooklyn_nets.webp',
  },
  'New York Knicks': {
    displayName: 'NYK Knicks',
    logoUrl: 'nba/new_york_knicks.webp',
  },
  'Philadelphia 76ers': {
    displayName: 'PHI 76ers',
    logoUrl: 'nba/philadelphia_76ers.webp',
  },
  'Toronto Raptors': {
    displayName: 'TOR Raptors',
    logoUrl: 'nba/toronto_raptors.webp',
  },
  'Chicago Bulls': {
    displayName: 'CHI Bulls',
    logoUrl: 'nba/chicago_bulls.webp',
  },
  'Cleveland Cavaliers': {
    displayName: 'CLE Cavaliers',
    logoUrl: 'nba/cleveland_cavaliers.webp',
  },
  'Detroit Pistons': {
    displayName: 'DET Pistons',
    logoUrl: 'nba/detroit_pistons.webp',
  },
  'Indiana Pacers': {
    displayName: 'IND Pacers',
    logoUrl: 'nba/indiana_pacers.webp',
  },
  'Milwaukee Bucks': {
    displayName: 'MIL Bucks',
    logoUrl: 'nba/milwaukee_bucks.webp',
  },
  'Atlanta Hawks': {
    displayName: 'ATL Hawks',
    logoUrl: 'nba/atlanta_hawks.webp',
  },
  'Charlotte Hornets': {
    displayName: 'CHA Hornets',
    logoUrl: 'nba/charlotte_hornets.webp',
  },
  'Miami Heat': {
    displayName: 'MIA Heat',
    logoUrl: 'nba/miami_heat.webp',
  },
  'Orlando Magic': {
    displayName: 'ORL Magic',
    logoUrl: 'nba/orlando_magic.webp',
  },
  'Washington Wizards': {
    displayName: 'WAS Wizards',
    logoUrl: 'nba/washington_wizards.webp',
  },
  'Denver Nuggets': {
    displayName: 'DEN Nuggets',
    logoUrl: 'nba/denver_nuggets.webp',
  },
  'Minnesota Timberwolves': {
    displayName: 'MIN Timberwolves',
    logoUrl: 'nba/minnesota_timberwolves.webp',
  },
  'Oklahoma City Thunder': {
    displayName: 'OKC Thunder',
    logoUrl: 'nba/oklahoma_city_thunder.webp',
  },
  'Portland Trail Blazers': {
    displayName: 'POR Trail Blazers',
    logoUrl: 'nba/portland_trail_blazers.webp',
  },
  'Utah Jazz': {
    displayName: 'UTA Jazz',
    logoUrl: 'nba/utah_jazz.webp',
  },
  'Golden State Warriors': {
    displayName: 'GSW Warriors',
    logoUrl: 'nba/golden_state_warriors.webp',
  },
  'Los Angeles Clippers': {
    displayName: 'LA Clippers',
    logoUrl: 'nba/la_clippers.webp',
  },
  'Los Angeles Lakers': {
    displayName: 'LAL Lakers',
    logoUrl: 'nba/los_angeles_lakers.webp',
  },
  'Phoenix Suns': {
    displayName: 'PHX Suns',
    logoUrl: 'nba/phoenix_suns.webp',
  },
  'Sacramento Kings': {
    displayName: 'SAC Kings',
    logoUrl: 'nba/sacramento_kings.webp',
  },
  'Dallas Mavericks': {
    displayName: 'DAL Mavericks',
    logoUrl: 'nba/dallas_mavericks.webp',
  },
  'Houston Rockets': {
    displayName: 'HOU Rockets',
    logoUrl: 'nba/houston_rockets.webp',
  },
  'Memphis Grizzlies': {
    displayName: 'MEM Grizzlies',
    logoUrl: 'nba/memphis_grizzlies.webp',
  },
  'New Orleans Pelicans': {
    displayName: 'NOP Pelicans',
    logoUrl: 'nba/new_orleans_pelicans.webp',
  },
  'San Antonio Spurs': {
    displayName: 'SAS Spurs',
    logoUrl: 'nba/san_antonio_spurs.webp',
  },
  'San Antonio': {
    displayName: 'SAS Spurs',
    logoUrl: 'nba/san_antonio_spurs.webp',
  },
};
